import { defineStore } from 'pinia'

interface LangState {
  lang: string
}

interface LangActions {
  setSelectedLanguage: (selectedLanguage: string) => void
  getSelectedLanguage: () => string
}

export const useLangStore = defineStore<
  'lang',
  LangState,
  Record<string, any>,
  LangActions
>({
  id: 'lang',
  state: (): LangState => ({
    lang: 'ru',
  }),
  actions: {
    setSelectedLanguage(selectedLanguage: string) {
      this.lang = selectedLanguage
    },
    getSelectedLanguage(): string {
      return this.lang
    },
  },
})
